// eslint-disable-next-line import/prefer-default-export
export function extractStreetAndNumber(str) {
  const parts = (str || '').split(',').map(s => s.trim());

  if (parts.length === 1) {
    parts.push('');
  }

  return {
    street: parts.slice(0, -1).join(', '),
    number: parts.slice(-1).join(''),
  };
}
